import React, { useEffect, useState } from "react";
import "./Nav.scss";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
function Nav(props) {
  const [isShow, setIsShow] = useState(false);
  // const history = useHistory();
  const location = useLocation();
  const account = useSelector((state) => state.user.account);
  useEffect(() => {
    if (account.auth === true) {
      setIsShow(true);
    } else {
      if (location.pathname === "/login") {
        setIsShow(false);
      }
    }
  }, [account]);
  return (
    <>
      {isShow === true && (
        <div>
          <div className="topnav">
            <NavLink to="/admin" exact>
              App Managers
            </NavLink>
            <NavLink to="/users" exact>
              Tools
            </NavLink>
            {/* <NavLink to="/contact" exact>
              Contact
            </NavLink> */}
            <div></div>
            <NavLink to="/about" exact>
              About
            </NavLink>
          </div>
        </div>
      )}
    </>
  );
}

export default Nav;
